module.exports = __webpack_public_path__ + "img/chenyuanzhi.b0f8faa4.jpg";